import React from "react";
import MainTemplate from "../../../../components/MainTemplate/MainTemplate";
import DashboardChurchAdminChild from "./DashboardChurchAdminChild";

const DashboardChurchAdmin = () => {
  return (
    <MainTemplate>
      <DashboardChurchAdminChild />
    </MainTemplate>
  );
};

export default DashboardChurchAdmin;
